<div class="comment-box" style="padding-top:10px;">
  <div style="padding-top:10px;padding-bottom:10px;font-weight: 600;">New Message</div>
  <ckeditor #commentsEditor data=""></ckeditor>
  <div style="text-align:right;padding-top:10px;">
    <button class="btn btn-primary me-1" (click)="onAdd()">Send</button>
    <button *ngIf="this.comment" class="btn btn-danger me-1" (click)="onCancel()">Cancel</button>
  </div>
  </div>